<template>

    <b-modal id="memberTransactionModal" :title="modalTitle" ok-only ok-title="閉じる" size="xl"
        dialog-class="custom-wide-modal" modal-class="agent-netenglish-modal">
        <div class="card esi-card mt-4">
            <div class="card-header esi-card-header">
                レッスン履歴
            </div>
            <div class="card-body esi-card-body overflow-auto">

                <div v-if="memberSummary" class="mb-3 small">
                    <div class="row">
                        <div class="col-md-2 font-weight-bold">受講生名</div>
                        <div class="col-md-10">{{ memberSummary }}</div>
                    </div>
                </div>

                <div v-if="loading">読み込み中...</div>
                <div v-if="error" class="text-danger">{{ error }}</div>

                <div v-if="schedules.length">

                    <table cellspacing="0" cellpadding="0" class="table table-striped table-bordered" width="100%">
                        <thead>
                            <tr>
                                <th>レッスン日</th>
                                <th>レッスン時間</th>
                                <th>アカウント</th>
                                <th>ステータス</th>
                                <th>講師</th>
                                <th>メモ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="schedule in schedules" :key="'schedule-' + schedule.id">
                                <td>{{ formatLessonDate(schedule.lesson_time) }}</td>
                                <td>{{ formatLessonTimeRange(schedule) }}</td>
                                <td class="text-left">
                                    <span class="badge badge-primary small">AC{{ scheduleAccountId(schedule) }}</span>
                                    <span v-if="scheduleAccountName(schedule)" class="ml-1">{{ scheduleAccountName(schedule) }}</span>
                                    <span v-else class="ml-1 small text-muted">~</span>
                                </td>
                                <td>
                                    <span v-if="schedule.valid === false || schedule.valid === 0" class="text-danger">
                                        {{ formatScheduleStatusJa(schedule.schedule_status) }}（上書き済み）
                                    </span>
                                    <span v-else>{{ formatScheduleStatusJa(schedule.schedule_status) }}</span>
                                </td>
                                <td>{{ formatTutorName(schedule) }}</td>
                                <td style="min-width: 200px;">{{ schedule.memo || '' }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="lastPage > 1" class="pagination">
                        <button type="button" class="btn btn-sm mr-1" disabled>ページ {{ currentPage }} / {{ lastPage }}</button>
                        <button type="button" @click="prevPage" :disabled="currentPage === 1"
                            class="btn btn-primary btn-sm mr-1">前へ</button>
                        <button v-for="page in pageNumbers" :key="page" type="button"
                            :class="{ active: currentPage === page }"
                            class="mr-1 btn btn-primary btn-sm" @click="goToPage(page)">
                            {{ page }}
                        </button>
                        <button type="button" @click="nextPage" :disabled="currentPage === lastPage"
                            class="btn btn-primary btn-sm mr-1">次へ</button>
                    </div>
                </div>
                <div v-else>
                    <span v-if="loading == false">レッスン履歴はありません。</span>
                </div>

            </div>
        </div>

    </b-modal>

</template>

<style>
.custom-wide-modal {
    max-width: 95%;
    width: 95%;
}
</style>

<style scoped>
.card-body.overflow-auto {
    overflow: auto;
}

.pagination {
    display: inline-block !important;
}
</style>

<script>
export default {
    props: {
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            schedules: [],
            loading: false,
            error: null,
            currentPage: 1,
            lastPage: 1,
            perPage: 15,
            memberId: null,
            memberSummary: '',
            pageNumbers: [],
        };
    },
    computed: {
        modalTitle() {
            return this.memberSummary ? `レッスン履歴 — ${this.memberSummary}` : 'レッスン履歴';
        },
    },
    methods: {
        reset() {
            this.schedules = [];
            this.loading = false;
            this.error = null;
            this.currentPage = 1;
            this.lastPage = 1;
            this.memberId = null;
            this.memberSummary = '';
            this.pageNumbers = [];
        },
        openMemberTransactionHistory(member) {
            this.reset();
            this.memberId = member.user_id;
            const name = [member.lastname, member.firstname].filter(Boolean).join(' ').trim();
            this.memberSummary = name || `ID ${member.user_id}`;
            this.$bvModal.show('memberTransactionModal');
            this.getLessonHistory();
        },
        async getLessonHistory(page = 1) {
            if (!this.memberId) {
                return;
            }

            this.loading = true;
            this.currentPage = page;
            this.schedules = [];
            this.error = null;

            try {
                const response = await axios.post('/api/getMemberLessonHistory?api_token=' + this.api_token, {
                    method: 'POST',
                    agent_user_id: this.$props.agent_user_id,
                    memberID: this.memberId,
                    page: this.currentPage,
                    per_page: this.perPage,
                });

                if (response.data.success === false) {
                    this.error = response.data.message || 'レッスン履歴の取得に失敗しました。';
                } else {
                    const payload = response.data.schedules || {};
                    this.schedules = payload.data || [];
                    this.lastPage = payload.last_page || 1;
                    this.updatePageNumbers();
                }
            } catch (err) {
                this.error = 'レッスン履歴の取得に失敗しました。';
            } finally {
                this.loading = false;
            }
        },
        goToPage(num) {
            this.getLessonHistory(num);
        },
        nextPage() {
            if (this.currentPage < this.lastPage) {
                this.getLessonHistory(this.currentPage + 1);
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.getLessonHistory(this.currentPage - 1);
            }
        },
        scheduleAccountId(schedule) {
            return schedule.member_multi_account_id
                || (schedule.multi_account && schedule.multi_account.member_multi_account_id)
                || 1;
        },
        scheduleAccountName(schedule) {
            return schedule.multi_account && schedule.multi_account.name
                ? schedule.multi_account.name
                : '';
        },
        formatTutorName(schedule) {
            const firstname = schedule.tutor && schedule.tutor.user
                ? schedule.tutor.user.firstname
                : '';
            if (schedule.schedule_status === 'WRITING') {
                return firstname || '未選択';
            }
            return firstname || '';
        },
        formatScheduleStatusJa(status) {
            const key = String(status || '').toUpperCase().replace(/\s+/g, '_');
            const labels = {
                CLIENT_RESERVED: '予約済み',
                CLIENT_RESERVED_B: '予約済み',
                CLIENT_NOT_AVAILABLE: '欠席',
                COMPLETED: '完了',
                WRITING: 'ライティング',
                TUTOR_SCHEDULED: '空き',
                SUPPRESSED_SCHEDULE: '休講',
                TUTOR_CANCELLED: '講師キャンセル',
            };
            return labels[key] || status;
        },
        formatLessonDate(dateString) {
            if (!dateString) {
                return '';
            }
            const date = new Date(dateString);
            const jstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);
            if (jstDate.getHours() === 0) {
                jstDate.setDate(jstDate.getDate() - 1);
            }
            return `${jstDate.getFullYear()}年 ${String(jstDate.getMonth() + 1).padStart(2, '0')}月 ${String(jstDate.getDate()).padStart(2, '0')}日`;
        },
        formatLessonTime(dateString) {
            if (!dateString) {
                return '';
            }
            const date = new Date(dateString);
            const jstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);
            if (jstDate.getHours() === 0) {
                return `24:${String(jstDate.getMinutes()).padStart(2, '0')}`;
            }
            return `${String(jstDate.getHours()).padStart(2, '0')}:${String(jstDate.getMinutes()).padStart(2, '0')}`;
        },
        formatLessonTimeRange(schedule) {
            if (!schedule.lesson_time) {
                return '';
            }
            const start = this.formatLessonTime(schedule.lesson_time);
            const startDate = new Date(schedule.lesson_time);
            const minutes = schedule.schedule_status === 'WRITING'
                ? 25
                : (parseInt(schedule.duration, 10) || 0);
            const endDate = new Date(startDate.getTime() + minutes * 60 * 1000);
            const end = this.formatLessonTime(endDate.toISOString());
            return `${start} - ${end}`;
        },
        updatePageNumbers() {
            const maxPagesToShow = 15;
            const halfRange = Math.floor(maxPagesToShow / 2);
            let startPage = this.currentPage - halfRange;
            let endPage = this.currentPage + halfRange;

            if (startPage < 1) {
                startPage = 1;
                endPage = Math.min(maxPagesToShow, this.lastPage);
            }
            if (endPage > this.lastPage) {
                endPage = this.lastPage;
                startPage = Math.max(1, this.lastPage - maxPagesToShow + 1);
            }

            this.pageNumbers = [];
            for (let i = startPage; i <= endPage; i++) {
                this.pageNumbers.push(i);
            }
        },
    },
};
</script>
